import clsx from 'clsx'
import React, { MouseEventHandler } from 'react'

import s from './styles.module.scss'

import { MostBookedRegionType } from '../../location-picker.type'
import { Icon } from '../../../../atoms'

interface ListItemProps {
  item: any
  onClick: MouseEventHandler<HTMLButtonElement>
  revampEnabled?: boolean
}

interface ListItemMostBookedRegionProps {
  item: MostBookedRegionType
  onClick: MouseEventHandler<HTMLButtonElement>
}

export const ListItem = ({
  item,
  onClick,
  revampEnabled = false,
}: ListItemProps) => {
  return (
    <button
      aria-label={item.description}
      onClick={onClick}
      className={clsx({
        [s.revampItem]: revampEnabled,
        [s.item]: !revampEnabled,
      })}
    >
      <span className={s.icon}>
        <Icon name='map-pointer' size={12} />
      </span>
      {item.description}
    </button>
  )
}

export const ListItemMostBookedRegion = ({
  item,
  onClick,
}: ListItemMostBookedRegionProps) => {
  return (
    <button
      aria-label={item.label}
      onClick={onClick}
      className={s.itemMostBookedRegion}
    >
      <div className={s.picture}>
        <img src={item.picture} alt={item.label} />
      </div>
      <div className={s.label}>{item.label}</div>
    </button>
  )
}
